import React, { FC, memo, useState } from 'react';
import { Async } from 'react-select';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  className?: any;
  name?: any;
  placeholder?: string;
  onChange: (value: any) => void;
}

const CustomerSelect: FC<Props> = ({ className, name, placeholder, onChange }) => {
  const [value, setValue] = useState<{ value: string; label: string }>();
  const { fetch } = useAuth();

  const handleChange = (value?: { value: string; label: string }) => {
    setValue(value);
    onChange({ id: value?.value, name: value?.label });
  };

  const findDealCustomer = (customerName: string) => {
    const graphQL =
      `{customers(socialReason:"${customerName}", socialReasonOperator:Contient, offset: 0, limit: 15)` +
      '{ items{ id, installationSite{ socialReason }}}}';

    return fetch(`/api/customer/${graphQL}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((json) => {
        let customers = json.data.customers?.items || [];

        customers = customers.map((customer) => ({
          value: customer.id,
          label: customer.installationSite.socialReason,
        }));

        return { options: customers };
      });
  };

  return (
    <Async
      className={className}
      name={name}
      value={value}
      loadOptions={findDealCustomer}
      filterOptions={(options) => {
        // Do no filtering, just return all options
        return options;
      }}
      onChange={handleChange}
      placeholder={placeholder}
      noResultsText='Aucun résultat'
      clearValueText='Supprimer'
    />
  );
};

export default memo(CustomerSelect);
